import React from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollToTopButton = ({ show, onClick, themeColor }) => {
    return (
        <button
            type="button"
            className={`scroll-to-top-btn ${show ? 'visible' : ''}`}
            onClick={onClick}
            aria-label="رفتن به بالای صفحه"
            style={{
                borderColor: themeColor,
                color: themeColor,
                boxShadow: show ? `0 4px 18px ${themeColor}40` : 'none'
            }}
        >
            <FaArrowUp size={18} />
        </button>
    );
};

export default React.memo(ScrollToTopButton);
